import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usageHistory: [],
  tokenPackages: [],
  loading: false,
  skaiCancelLoading: false,
  // Floating SkAi Beam widget chat state (persisted across page navigation)
  chatMessages: [],
  chatHasGreeted: false,
  chatConversationSummary: "",
};

const skaiSlice = createSlice({
  name: "skai",
  initialState,
  reducers: {
    setSkaiTokenUsage: (state, action) => {
      state.usageHistory = action.payload;
    },
    resetSkaiState: () => initialState,
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTokenPackages: (state, action) => {
      state.tokenPackages = action.payload;
    },
    setSkaiLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCancelSkaiLoading: (state, action) => {
      state.skaiCancelLoading = action.payload;
    },
    setChatMessages: (state, action) => {
      state.chatMessages = action.payload;
    },
    setChatHasGreeted: (state, action) => {
      state.chatHasGreeted = action.payload;
    },
    setChatConversationSummary: (state, action) => {
      state.chatConversationSummary = action.payload;
    },
  },
});

export const {
  setSkaiTokenUsage,
  resetSkaiState,
  setLoading,
  setSkaiLoading,
  setTokenPackages,
  setCancelSkaiLoading,
  setChatMessages,
  setChatHasGreeted,
  setChatConversationSummary,
} = skaiSlice.actions;
export default skaiSlice.reducer;
